import * as PropTypes from 'prop-types';
import { CustomFieldsMap, FIELDS } from 'components/forms';
import { isFormFieldSelectbox } from 'pages/upload.page/utils';
import { EDIT_MY_VIDEO_FORM } from '..';

export const FormFields = ({ videoFormConfig, formValues }) =>
  videoFormConfig
    .filter((cfg) => cfg.type !== FIELDS.TEXT_BOX)
    .map((cfg, index) => {
      if (isFormFieldSelectbox(cfg.type)) {
        return CustomFieldsMap[cfg.type](cfg.config, index, cfg.type, EDIT_MY_VIDEO_FORM, formValues);
      }

      return CustomFieldsMap[cfg.type](cfg.config, index);
    });

FormFields.propTypes = {
  videoFormConfig: PropTypes.array.isRequired,
  formValues: PropTypes.object,
};
